export default "__VITE_ASSET__C9U9IZRw__"